/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Owner_Badge_TooltipInputs */



/**
* | output |
* | --- |
* | "This chat belongs to {name}. Sending a message will create your own copy." |
*
* @param {Chat_Owner_Badge_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_owner_badge_tooltip = /** @type {((inputs: Chat_Owner_Badge_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Owner_Badge_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieser Chat gehört ${i?.name}. Beim Senden einer Nachricht wird eine eigene Kopie erstellt.`)
	return /** @type {LocalizedString} */ (`This chat belongs to ${i?.name}. Sending a message will create your own copy.`)
});